import { useState } from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton
} from '@mui/material'
import TextLabel from '../../../../../components/form/TextLabel/TextLabel'
import css from './DatosContacto.module.css'

const DatosContacto = ({ lead, onEdit }) => {
  const [isExpanded, setExpanded] = useState(true)

  const handleChange = (_event, isExpanded) => {
    setExpanded(isExpanded)
  }

  const handleEdit = e => {
    e.stopPropagation()
    onEdit()
  }

  const isPropioAlumno = lead.contacto === 'Propio Alumno'
  return (
    <Accordion expanded={isExpanded} onChange={handleChange}>
      <AccordionSummary
        expandIcon={<i className='material-icons'>expand_more</i>}
      >
        <div className={css.label}>
          <Typography className={css.title} variant='h2'>
            Datos contacto
          </Typography>
          {isExpanded && (
            <IconButton
              className={css.button}
              size='small'
              color='secondary'
              onClick={handleEdit}
            >
              <i className='material-icons'>edit</i>
            </IconButton>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails className={css.details}>
        <div className={css.column}>
          <TextLabel
            className={css.field}
            name='relacion'
            label='Persona de contacto'
            value={lead.contacto}
          />
          <TextLabel
            className={css.field}
            name='nombre'
            label='Nombre contacto'
            value={lead.nombreContacto}
          />
        </div>
        <div className={css.column}>
          <TextLabel
            className={css.field}
            name='relacion'
            label='Persona de interés'
            value='Alumno'
            disabled
          />
          <TextLabel
            className={css.field}
            name='nombre'
            label='Nombre del alumno'
            value={lead.nombreAlumno}
            disabled={isPropioAlumno}
          />
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default DatosContacto
